import type { BatchArgs } from '@carboncopyco/types';
import { removeUndefinedValues } from '@carboncopyco/utils';

const PAGE_SIZE = 30;

export const handleBatchRequest = <S>({
  url,
  limit = PAGE_SIZE,
  enrich,
  mineOnly,
  sort,
  query,
  nextBatchCursor,
  params,
  method = 'GET',
  headers,
}: BatchArgs<S> & {
  url: string;
  params?: Record<string, string>;
  headers?: Record<string, string>;
}) => {
  return {
    url,
    method,
    params: {
      ...params,
      ...removeUndefinedValues({
        limit,
        enrich,
        mineOnly,
        sort,
        query,
      }),
    },
    headers: nextBatchCursor
      ? { 'x-cursor': nextBatchCursor, ...headers }
      : headers,
  };
};
